import { ConnectedProps, legacy_connect as connect } from 'react-redux';

import UniqueId from '../../../../../services/uid/UniqueId';
import { AppState } from '../../../../../store/reducers/root';
import { getIsCommandsCreated } from '../../../../../store/selectors/commands';
import {
  getDatasetRows,
  getDatasetRowsFullCount,
  getDatasetSelectedIds,
  getDatasetTitle,
  isDatasetOpen,
} from '../../../../../store/selectors/dataset';

import CategoryDataset from './CategoryDataset';

interface OwnProps {
  datasetId: UniqueId;
  showCommands: boolean;
  tabIndex?: number;
}

const mapStateToProps = (
  state: AppState,
  { datasetId, showCommands, tabIndex }: OwnProps
) => {
  const datasetCreated = isDatasetOpen(state, datasetId);

  return {
    datasetId,
    showCommands,
    tabIndex,
    datasetCreated,
    isCommandsCreated: getIsCommandsCreated(state, datasetId),
    rowsCount: datasetCreated ? getDatasetRows(state, datasetId).length : 0,
    fullCount: datasetCreated ? getDatasetRowsFullCount(state, datasetId) : 0,
    title: getDatasetTitle(state, datasetId),
    selected: datasetCreated
      ? getDatasetSelectedIds(state, datasetId).length
      : 0,
  };
};

const connector = connect(mapStateToProps);

export type CategoryDatasetContainerProps = ConnectedProps<typeof connector>;

export default connector(CategoryDataset);
